import React from "react";
import { Link } from "react-router-dom";

export default function PaymentIconLink() {
  return (
    <div className="paymentInfoArea" title="Enjoy services Buy Subscription">
      <Link
        to="/subscription"
        className="btn btn-primary btn-sm"
        target="_blank"
      >
        <i className="fa fa-info-circle"></i>
      </Link>
    </div>
  );
}
